<template>
  <div class="soundsBasicForm">
    <el-form-item label="introduction">
      <el-input
        v-model="local.introduction"
        type="textarea"
        :rows="3"
        placeholder="请输入"
      />
    </el-form-item>
    <el-form-item label="singnature">
      <el-input
        v-model="local.singnature"
        type="textarea"
        :rows="3"
        placeholder="请输入"
      />
    </el-form-item>
  </div>
</template>

<script>
import basicFormMixin from './basicFormMixin'

export default {
  name: 'SoundsBasicForm',
  mixins: [basicFormMixin],
  data() {
    return {
      local: {
        introduction: '',
        singnature: '',
      },
    }
  },
  methods: {
    buildExtaPayload() {
      const data = {}
      data.introduction = this.local.introduction
        ? JSON.stringify(this.local.introduction)
        : ''
      data.singnature = this.local.singnature
        ? JSON.stringify(this.local.singnature)
        : ''
      return data
    },
    loadFromExta(exta) {
      const data = exta || {}
      if (data.introduction) {
        try {
          this.local.introduction = JSON.parse(data.introduction)
        } catch (e) {
          this.local.introduction = data.introduction
        }
      } else {
        this.local.introduction = ''
      }
      if (data.singnature) {
        try {
          this.local.singnature = JSON.parse(data.singnature)
        } catch (e) {
          this.local.singnature = data.singnature
        }
      } else {
        this.local.singnature = ''
      }
    },
    reset() {
      this.local = { introduction: '', singnature: '' }
    },
    captureSnapshot() {
      return { ...this.local }
    },
  },
}
</script>
